import * as commonConstants from "../constants/common";
import jwtdecode from 'jwt-decode';

export function isLoggedIn() {
    let token = getToken();

    if (token === null) {
        return false;
    }
    return true;
}

export function getToken() {
    let token = null;
    let localToken = window.localStorage.getItem(commonConstants.TOKEN_KEY);
    let sessionToken = window.sessionStorage.getItem(commonConstants.TOKEN_KEY);

    if (sessionToken !== null) {
        token = sessionToken;
    } else if (localToken !== null) {
        setToken(localToken);
        token = localToken;
    }

    if (token !== null) {
        let decodedToken = jwtdecode(token);
        if (parseInt(Date.now() / 1000, 10) > decodedToken.exp) {
            clearTokenAndUser();
            token = null;
        }
    }
    return token;
}

export function setToken(token) {
    if (token !== null) {
        window.localStorage.setItem(commonConstants.TOKEN_KEY, token);
        window.sessionStorage.setItem(commonConstants.TOKEN_KEY, token);
    }
}

export function clearTokenAndUser() {
    window.localStorage.removeItem(commonConstants.TOKEN_KEY);
    window.sessionStorage.removeItem(commonConstants.TOKEN_KEY);

    window.localStorage.removeItem(commonConstants.USER_KEY);
}

export function setUser(user) {
    if (user !== null) {
        window.localStorage.setItem(commonConstants.USER_KEY, JSON.stringify(user));
    }
}

export function getUser() {
    let user = window.localStorage.getItem(commonConstants.USER_KEY);
    if (user !== null && user !== undefined) {
        return JSON.parse(user);
    }
    return null;
}

export function isAdmin(user) {
    let isValid = false;

    if (user !== undefined) {
        if (user.role !== undefined) {
            if (user.role.code === "ROLE_ADMIN") {
                isValid = true;
            }
        }
    }

    return isValid;
}

export function isValidUser(user) {
    let isValid = false;

    if (user !== undefined) {
        if (user !== undefined) {
            if (user.name !== undefined && user.email !== undefined) {
                isValid = true;
            }
        }
    }

    return isValid;
}


// WEBPACK FOOTER //
// ./src/utils/authHandler.js